export const DISPLAY_ERROR = 'DISPLAY_ERROR';
export const CLOSE_ERROR = 'CLOSE_ERROR';
